import { render, staticRenderFns } from "./ApplicationReviewStatus.vue?vue&type=template&id=4b3029c3&"
import script from "./ApplicationReviewStatus.vue?vue&type=script&lang=ts&"
export * from "./ApplicationReviewStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports